import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignInPage from './pages/SingIn/SingInPage';
import HomePage from './pages/HomePage';
import PrivateLayout from './layouts/PrivateLayout';
import RegisterEmpleadoPage from './pages/RegisterEmpleado/RegisterEmpleadoPage';
import { hasRole, isTokenValid } from './utils/auth';
import { ROLES } from './utils/roles';
import EmpleadoList from './components/EmpleadoList';
import DatosEntrada from "./components/DatosEntrada";
import PaginaEntradaConTicket from "./pages/PaginaEntradaConTicket";
import MisDatos from "./pages/MisDatos/MisDatos";
import Estadisticas from "./pages/Stadistics/DashboardEstadisticas";
import EventosPage from "./pages/Eventos/EventosPage";

const App = () => {
    const [authToken, setAuthToken] = useState(localStorage.getItem('jwt'));
    const isAuthenticated = isTokenValid(authToken);

    useEffect(() => {
        const syncAuth = () => {
            setAuthToken(localStorage.getItem('jwt'));
        };

        window.addEventListener('authChange', syncAuth);
        return () => window.removeEventListener('authChange', syncAuth);
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                {/* Rutas privadas protegidas por autenticación */}
                {isAuthenticated && (
                    <Route element={<PrivateLayout />}>
                        <Route path="/" element={<HomePage />} />
                        {/* Aquí otras rutas privadas */}
                        <Route path="/personal/ticket" element={<PaginaEntradaConTicket/>} />
                        <Route path="/mis-datos" element={<MisDatos />} />
                        <Route path="/personal/eventos" element={<EventosPage/>}/>
                        {/* Rutas solo para propietario */}
                        {hasRole(authToken, ROLES.PROPIETARIO) && (
                            <>
                                <Route path="/propietario/entrada" element={<DatosEntrada />} />
                                <Route path="/propietario/listar-empleados" element={<EmpleadoList />} />
                                <Route path="/propietario/registrar-empleado" element={<RegisterEmpleadoPage />} />
                                <Route path="/propietario/estadisticas" element={<Estadisticas />} />
                            </>
                        )}
                    </Route>
                )}

                {/* Login solo para no autenticados */}
                <Route
                    path="/login"
                    element={!isAuthenticated ? <SignInPage /> : <Navigate to="/" replace />}
                />

                {/* Redireccionar cualquier ruta no reconocida */}
                <Route
                    path="*"
                    element={<Navigate to={isAuthenticated ? "/" : "/login"} replace />}
                />
            </Routes>
        </BrowserRouter>
    );
};

export default App;
